// pages/RulesPage.jsx
import { Grid, Stack, Paper, Typography, Button } from "@mui/material";
import PageShell from "../components/PageShell";
import { getIconEl } from "../components/utils";
import DownloadIcon from "@mui/icons-material/Download";

/**
 * Rules page (extracted from App.jsx)
 * Props: { data }
 */
export default function RulesPage({ data }) {
  const intro = data?.rules?.intro ?? data?.rulesIntro ?? "Sporting code, stewarding process, and incident reporting.";
  const sections = data?.rules?.sections ?? [];

  return (
    <PageShell title="Rules & Regulations" bannerImage="rules.png">
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Typography sx={{ mb: 2 }}>{intro}</Typography>
          <Stack spacing={2}>
            {sections.length > 0 ? sections.map((s, idx) => (
              <Paper key={(s.title || "Section") + "-" + idx} variant="outlined" sx={{ p: 2.5, borderRadius: 3 }}>
                {s.title && (
                  <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                    {getIconEl("Rule", { fontSize: "small", color: "primary" })}
                    <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>{s.title}</Typography>
                  </Stack>
                )}

                {s.body && (
                  <Typography variant="body2" color="text.secondary" sx={{ mb: (s.list || s.link || s.pointsTable || s.bonus || s.tiebreakers) ? 1.5 : 0 }}>
                    {s.body}
                  </Typography>
                )}

                {/* Rule content (lists, tables, etc.) */}
                {Array.isArray(s.list) && s.list.length > 0 && (
                  <Stack component="ul" sx={{ pl: 2, m: 0 }} spacing={0.5}>
                    {s.list.map((item, i) => (
                      <Typography key={i} component="li" variant="body2" color="text.secondary">{item}</Typography>
                    ))}
                  </Stack>
                )}

                {s.link?.href && s.link?.label && (
                  <Button
                    component="a"
                    href={s.link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    size="small"
                    sx={{ mt: s.list?.length ? 1.5 : 0 }}
                  >
                    {s.link.label}
                  </Button>
                )}
              </Paper>
            )) : (
              <Typography color="text.secondary">
                Full sporting code coming soon. Check Discord for interim guidance.
              </Typography>
            )}
          <Button variant="contained"
            component="a"
            startIcon={<DownloadIcon />}
            href={`https://drive.google.com/file/d/1OKirO5ktzZtPguFpEVBmoXscIZEqphPi/view?usp=sharing`}
            download="ARL_Disciplinary.pdf">
            Download ARL Disciplinary Process
          </Button>
          </Stack>
        </Grid>
      </Grid>
    </PageShell>
  );
}
